import {
  AppHeader,
  AppHeaderBackButton,
  Box,
  Container,
  Stack,
  Typography,
} from '@ace-clublabs/shared-component-library';
import { SelectMembershipSection } from '../components/SelectMembership/SelectMembershipSection';
import { useGlobalState } from '../state/state';
import { useLayoutEffect, useState } from 'react';
import { UtagHelper, UtagType } from '../utils/UtagHelper';
import { GreenBoxMessage } from '../components/GreenBox/GreenBoxMessage';
import { getIsInMidterm } from '../utils/ruleHelper';

export const ChangeBenefitLevel: React.FC = () => {
  const [isMobileApp] = useGlobalState('isMobileApp');
  const [tags] = useGlobalState('tags');
  const [isTagging, setTagging] = useState(true);
  const [content] = useGlobalState('content');
  const [memberDetails] = useGlobalState('memberDetails');
  const isInMidterm = getIsInMidterm(memberDetails);
  const isInRenewal = memberDetails.inRenewal;

  useLayoutEffect(() => {
    UtagHelper.sendTag(UtagType.view, tags, 'select benefit level');
    setTagging(false);
  }, []);

  if (isTagging) {
    return <></>;
  }

  return (
    <>
      <Container maxWidth="lg">
        <Box
        >
          <AppHeader backButton={!isMobileApp && <AppHeaderBackButton />} />
          <Stack alignItems="center">
            <Typography variant="h5" sx={{ marginBottom: '1rem' }} className="change-membership-title">
              {isInMidterm
                ? 'Upgrade your membership to unlock even more value'
                : isInRenewal
                ? 'Renew today for continuous peace of mind'
                : 'Select the best benefit level for you'}
            </Typography>
            {content.greenBoxMessage && (
              <GreenBoxMessage
                shortBoxMessage={content.greenBoxMessage.shortBoxMessage}
                modalTitle={content.greenBoxMessage.modalTitle}
                modalBody={content.greenBoxMessage.modalBody}
              />
            )}
            <SelectMembershipSection />
          </Stack>
        </Box>
      </Container>
    </>
  );
};
